const OPERATION_TYPE_KEYS: Record<string, string> = {
  receipt: 'catalog.movements.operationTypes.receipt',
  issue: 'catalog.movements.operationTypes.issue',
  transfer: 'catalog.movements.operationTypes.transfer',
  adjustment: 'catalog.movements.operationTypes.adjustment',
  internalconsumption: 'catalog.movements.operationTypes.internalConsumption'
};

export function inventoryOperationTypeKey(operationType: string): string | null {
  const normalized = operationType.replace(/-/g, '').toLowerCase();
  return OPERATION_TYPE_KEYS[normalized] ?? null;
}

export function inventoryOperationTypeLabel(
  operationType: string,
  translate: (key: string) => string
): string {
  const key = inventoryOperationTypeKey(operationType);
  if (!key) {
    return operationType;
  }

  const translated = translate(key);
  return translated === key ? operationType : translated;
}

export function inventoryOperationTypeOptions(translate: (key: string) => string): { label: string; value: string }[] {
  return [
    { label: inventoryOperationTypeLabel('receipt', translate), value: 'receipt' },
    { label: inventoryOperationTypeLabel('issue', translate), value: 'issue' },
    { label: inventoryOperationTypeLabel('transfer', translate), value: 'transfer' },
    { label: inventoryOperationTypeLabel('adjustment', translate), value: 'adjustment' },
    { label: inventoryOperationTypeLabel('internal-consumption', translate), value: 'internal-consumption' }
  ];
}

export function isTransferOperationType(operationType: string): boolean {
  return inventoryOperationTypeKey(operationType) === OPERATION_TYPE_KEYS['transfer'];
}
